<template>
    <b-modal
        :id="refName"
        :ref="refName"
        :title="$t('group.internship.select_groups')"
        ok-only
        @ok="onOk"
        @show="onShow"
        :ok-title="buttonText"
        size="lg"
        modal-class="apprentice-default-modal">
        <div class="groups">
            <div class="las-groups">
                <div class="row">
                    <div class="col-12 col-md-6 selected-las-groups">
                        <div class="component-title">
                            <h5 class="title">{{ $t('group.internship.linked_classes') }}</h5>
                        </div>

                        <div
                            class="las-group-list"
                            v-if="lasGroups.length >= 1">
                            <b-list-group
                                class="las-group-item"
                                v-for="las_group in groupIn.las_groups"
                                :key="las_group.id">
                                <div class="las-group-name">{{ las_group.name }}</div>
                                <b-button
                                    class="btn-remove btn-remove-las-group-item"
                                    v-b-tooltip.hover
                                    variant="danger-icon-only"
                                    :title="$t('common.delete')"
                                    @click="removeLasGroup(las_group.id)"></b-button>
                            </b-list-group>
                        </div>

                        <div
                            class="not-found with-header empty-las-group-list"
                            v-else>
                            <div class="icon">
                                <i class="fas fa-exclamation-circle"></i>
                            </div>
                            <div class="alert-notice">{{ $t('group.internship.no_linked_classes') }}}</div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 choose-las-groups">
                        <div class="component-title">
                            <h5 class="title">{{ $t('group.internship.select_class') }}</h5>
                        </div>

                        <div class="add-las-group">
                            <b-form-group
                                :label="$t('group.internship.classes')"
                                label-for="las-group-select">
                                <design-2021-apprentice-multiselect-component
                                    id="las-group-select"
                                    v-model="selectedLasGroup"
                                    label="name"
                                    track-by="id"
                                    :options="nonConnectedLasGroups"
                                    :multiple-select="false">
                                </design-2021-apprentice-multiselect-component>
                            </b-form-group>

                            <div class="store-las-group">
                                <b-button
                                    class="btn-add"
                                    variant="primary"
                                    :disabled="!selectedLasGroup"
                                    @click="addLasGroup"
                                    >{{ $t('common.add') }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="main-groups">
                <div class="row">
                    <div class="col-12 col-md-6 selected-main-groups">
                        <div class="component-title">
                            <h5 class="title">{{ $t('group.internship.connected_main_groups') }}</h5>
                        </div>

                        <div
                            class="main-group-list"
                            v-if="lasMainGroups.length >= 1">
                            <b-list-group
                                class="main-group-item"
                                v-for="las_main_group in groupIn.las_main_groups"
                                :key="las_main_group.id">
                                <div class="main-group-name">{{ las_main_group.name }}</div>
                                <b-button
                                    class="btn-remove btn-remove-main-group-item"
                                    v-b-tooltip.hover
                                    variant="danger-icon-only"
                                    title="Verwijderen"
                                    @click="removeLasMainGroup(las_main_group.id)"></b-button>
                            </b-list-group>
                        </div>

                        <div
                            class="not-found with-header empty-main-group-list"
                            v-else>
                            <div class="icon">
                                <i class="fas fa-exclamation-circle"></i>
                            </div>
                            <div class="alert-notice">{{ $t('group.internship.no_main_groups_connected') }}</div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 choose-main-groups">
                        <div class="component-title">
                            <h5 class="title">{{ $t('group.internship.select_main_group') }}</h5>
                        </div>

                        <div class="add-main-group">
                            <b-form-group
                                :label="$t('group.internship.main_groups')"
                                label-for="main-group-select">
                                <design-2021-apprentice-multiselect-component
                                    id="main-group-select"
                                    v-model="selectedLasMainGroup"
                                    label="name"
                                    track-by="id"
                                    :options="nonConnectedLasMainGroups"
                                    :multiple-select="false">
                                </design-2021-apprentice-multiselect-component>
                            </b-form-group>

                            <div class="store-main-group">
                                <b-button
                                    class="btn-add"
                                    variant="primary"
                                    :disabled="!selectedLasMainGroup"
                                    @click="addLasMainGroup"
                                    >{{ $t('common.add') }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../../app';

export default {
    name: 'design-2021-group-show-connect-las-modal-component',
    props: {
        groupIn: {
            type: Object,
            default: {},
        },
        buttonText: {
            type: String,
        },
        refName: {
            type: String,
        },
    },

    data() {
        return {
            loaded: false,
            selectedLasGroup: null,
            selectedLasMainGroup: null,
            lasGroups: [],
            lasMainGroups: [],
        };
    },

    computed: {
        nonConnectedLasGroups() {
            const lasGroup = this.lasGroups.filter((lasGroup) => {
                for (const lg of this.groupIn.las_groups) {
                    if (lg.id === lasGroup.id) {
                        return false;
                    }
                }
                return true;
            });

            lasGroup.unshift({ id: null, name: this.$t('group.internship.select_class') });

            return lasGroup;
        },

        nonConnectedLasMainGroups() {
            const mainGroup = this.lasMainGroups.filter((lasMainGroup) => {
                for (const lmg of this.groupIn.las_main_groups) {
                    if (lmg.id === lasMainGroup.id) {
                        return false;
                    }
                }
                return true;
            });

            mainGroup.unshift({ id: null, name: this.$t('group.internship.select_main_group') });

            return mainGroup;
        },
    },

    methods: {
        addLasGroup() {
            if (!this.selectedLasGroup) {
                return;
            }
            this.alert.saving();
            this.axios.post(this.routes.groupLasGroup(this.groupIn.id, this.selectedLasGroup.id)).then(
                (response) => {
                    this.groupIn.attach('las_groups', this.selectedLasGroup.id);
                    this.selectedLasGroup = null;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        addLasMainGroup() {
            if (!this.selectedLasMainGroup) {
                return;
            }
            this.alert.saving();
            this.axios.post(this.routes.groupLasMainGroup(this.groupIn.id, this.selectedLasMainGroup.id)).then(
                (response) => {
                    this.groupIn.attach('las_main_groups', this.selectedLasMainGroup.id);
                    this.selectedLasMainGroup = null;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        removeLasGroup(id) {
            this.alert
                .confirm(
                    this.$t('group.internship.disconnect'),
                    this.$t('group.internship.are_you_sure_you_want_to_disconnect_this_class'),
                    this.$t('group.internship.disconnect'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios.delete(this.routes.groupLasGroup(this.groupIn.id, id)).then(
                        (response) => {
                            this.groupIn.detach('las_groups', id);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        removeLasMainGroup(id) {
            this.alert
                .confirm(
                    this.$t('group.internship.disconnect'),
                    this.$t('group.internship.are_you_sure_you_want_to_disconnect_this_class'),
                    this.$t('group.internship.disconnect'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios.delete(this.routes.groupLasMainGroup(this.groupIn.id, id)).then(
                        (response) => {
                            this.groupIn.detach('las_main_groups', id);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        onShow() {
            if (this.loaded) {
                return;
            }

            ords.use('las_groups')
                .get()
                .subscribe((lasGroups) => {
                    this.lasGroups = lasGroups;
                });

            ords.use('las_main_groups')
                .get()
                .subscribe((lasMainGroups) => {
                    this.lasMainGroups = lasMainGroups;
                });
        },
        onOk() {
            this.$emit('closed');
        },
    },
};
</script>

<style scoped lang="scss">
.las-groups,
.main-groups {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.las-groups {
    border-bottom: 3px dotted $border-color;
    padding-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.las-group-list,
.main-group-list {
    .las-group-item,
    .main-group-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top: map-get($grid-gutter-spacing, 'eight');
        padding-bottom: map-get($grid-gutter-spacing, 'eight');

        &:not(:last-child) {
            border-bottom: 3px dotted $border-color;
        }
    }
}

.store-las-group,
.store-main-group {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
</style>
